export const properCasifyString = (str: string): string =>
  str.replace(
    /\w\S*/g,
    (word: string) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
  )
